import script from "./sureOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./sureOrder.vue?vue&type=script&setup=true&lang=js"

import "./sureOrder.vue?vue&type=style&index=0&id=2a5dca6f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a5dca6f"]])

export default __exports__